export default class TerminationPayloadDTO {
    private id: number | null = null;

    private employmentTermination: Date | null = null;

    constructor(init?: Partial<TerminationPayloadDTO>) {
        Object.assign(this, init)
    }
}